module.exports = __webpack_public_path__ + "static/media/uadvisory-mobile.aab8d413.svg";